import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: t = 16, useVw: n, useRem: l, color: o, withColor: c, removeClassName: e, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-tixian", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "24px-æç°"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M2.104 6.426a3.481 3.481 0 0 1 3.482-3.482h12.787a3.481 3.481 0 0 1 3.482 3.482v3.259a.8.8 0 0 1-1.6 0v-3.26a1.881 1.881 0 0 0-1.882-1.88H5.586a1.881 1.881 0 0 0-1.882 1.88v11.138c0 1.04.843 1.881 1.882 1.881h3.368a.8.8 0 0 1 0 1.6H5.586a3.481 3.481 0 0 1-3.482-3.48V6.425Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M17.705 13.369a.8.8 0 0 0 .003 1.131l1.858 1.85h-6.312a.8.8 0 1 0 0 1.6h6.313l-1.86 1.851a.8.8 0 0 0 1.13 1.134l3.232-3.217a.8.8 0 0 0 0-1.134l-3.232-3.218a.8.8 0 0 0-1.132.003ZM6.658 8.307a.8.8 0 0 0 0 1.6h5.363a.8.8 0 0 0 0-1.6H6.658Z"
        }
      )
    )
  )));
}, v = f;
export {
  v as default
};
